<template>
  <v-card
    class="toolbar-card"
    flat
    tile
  >
    <v-toolbar :elevation="0" :height="27" class="mini-toolbar">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            @click="$root.$emit('order-widget-list', { action: 1, value: true })"
            icon
            small
          >
            <v-icon small>
              mdi-checkbox-intermediate
            </v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.new.order.toolbar.check_all }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            @click="$root.$emit('order-widget-list', { action: 2, value: true })"
            icon
            small
          >
            <v-icon small>
              mdi-checkbox-blank-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ lang.orders.new.order.toolbar.uncheck_all }}</span>
      </v-tooltip>
      <v-divider
        class="mx-1"
        inset
        vertical
      ></v-divider>
      <template>
        <v-tooltip
          v-for="(menu, m_i) in get_global.defaults.options.orders.widget.menu[catalog]"
          :key="m_i"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click="$root.$emit('order-widget-list', { action: menu.action, value: true })"
              icon
              small
            >
              <v-icon v-text="menu.icon" small />
            </v-btn>
          </template>
          <span>{{ menu.title }}</span>
        </v-tooltip>
      </template>
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-menu bottom>
            <template v-slot:activator="{ on: menu }">
              <v-btn
                v-on="{ ...tooltip, ...menu }"
                icon
                small
              >
                <v-icon small>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(menu, mindx) in get_global.defaults.options.orders.widget.menu[catalog]"
                :key="mindx"
                @click.stop="$root.$emit('order-widget-list', { action: menu.action, value: true })"
              >
                <v-list-item-icon>
                  <v-icon v-text="menu.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ menu.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <span>{{ lang.orders.new.order.toolbar.actions.title }}</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
    </v-toolbar>
  </v-card>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    catalog: {
      type: String,
      default: 'services'
    }
  },
}
</script>
